import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { Account } from '../../models/account';
import { EmployeeRoleTypes } from '../../enums/employees/EmployeeRoleTypes';
import { GuardHelperService } from 'src/app/modules/auth/guard-helper.service';

@Injectable()
export class EmployeeRoleGuard {
  private requiredRoles: EmployeeRoleTypes[] = [];
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly guardHelperService: GuardHelperService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.requiredRoles = route.data['requiredRoles'];
    return this.guardHelperService.canActivate(route, state, undefined, this.checkPermissions.bind(this));
  }

  checkPermissions(account: Account): boolean {
    let result = false;
    const employee = this.authService.getCurrentEmployee();
    const requiredRoles: EmployeeRoleTypes[] = this.requiredRoles;

    if (!account.isActive)
      void this.router.navigateByUrl(`${account.accountUID}/unauthorized`);

    var employeeHasRequiredRole = employee.employeeRole.findIndex((a) => requiredRoles.findIndex((r) => r === a.roleId) > -1) > -1;

    if (employeeHasRequiredRole)
      result = true;

    if (!result)
      void this.router.navigateByUrl(`${account.accountUID}/access-denied`);

    return result;
  }
}
